import React from 'react';
import Header from './../containers/Header'
import Footer from './../containers/Footer'

export default class FourOFour extends React.Component {

  render() {
    return (
      <div className="main-container">
        <div id="wrap">
          <Header/>
          <div className="container center-container">
            <div className="center-row">
              <div className="col-xs-12">
                <h1>Can't seem to find that url 😞</h1>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/404.js